import { DATASOURCE_ACTION } from "./index";
import { requests } from "./requests";
import { portalService } from "../services";
import { formatMoment, deepGet } from "../../../utils";
import { source, isCancel } from "../../../api";
import { filterPractitionersBySpecialty } from "../helpers";

export const updateDataSource = (key, values) => {
  return {
    type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
    payload: {
      key,
      values
    }
  };
};

export const getTimeSlotsInPeriod = (
  start,
  end,
  locations,
  initialLoad = false,
  phoneConsult = false,
  concat = false
) => async (dispatch, getState) => {
  if (requests.getTimeSlots !== null) {
    requests.getTimeSlots.cancel();
  }

  requests.getTimeSlots = source();

  const { appointment, dataSource } = getState();
  const {
    specialtyType,
    appointmentType,
    practitioner,
    timezone
  } = appointment;
  let response = undefined;
  try {
    dispatch({
      type: DATASOURCE_ACTION.TOGGLE_TIMESLOTS_LOADING,
      payload: { loading: true }
    });

    response = await portalService.getTimeSlots(
      specialtyType,
      appointmentType,
      locations,
      practitioner === "ANY" ? "" : practitioner,
      timezone,
      formatMoment(start),
      formatMoment(end),
      phoneConsult
    );

    if (initialLoad && response.data.timeslots.length === 0) {
      response = await portalService.getTimeSlots(
        specialtyType,
        appointmentType,
        locations,
        practitioner === "ANY" ? "" : practitioner,
        timezone,
        formatMoment(start.add(1, "month").startOf("month")),
        formatMoment(end.add(1, "month").endOf("month")),
        phoneConsult
      );
      if (response.data.timeslots.length === 0) {
        response = await portalService.getTimeSlots(
          specialtyType,
          appointmentType,
          locations,
          practitioner === "ANY" ? "" : practitioner,
          timezone,
          formatMoment(start.add(1, "month").startOf("month")),
          formatMoment(end.add(1, "month").endOf("month")),
          phoneConsult
        );
      }
    }

    const { data } = response;
    const timeslots = data === null ? [] : data.timeslots || [];
    const practitionerIds = filterPractitionersBySpecialty(
      dataSource.practitioners,
      specialtyType
    ).map(p => p.practitionerId);
    const locationIds = dataSource.locations.map(l => l.locationId);

    dispatch({
      type: DATASOURCE_ACTION.UPDATE_TIMESLOTS,
      payload: {
        values: timeslots.filter(ts => {
          const practitionerId = deepGet(ts, [
            "practitioner",
            "practitionerId"
          ]);
          const locationId = ts.locationId;

          return (
            practitionerIds.includes(practitionerId) &&
            locationIds.includes(locationId)
          );
        }),
        concat
      }
    });
  } catch (e) {
    if (!isCancel(e)) {
      //error handling
    }
  }
  dispatch({
    type: DATASOURCE_ACTION.TOGGLE_TIMESLOTS_LOADING,
    payload: { loading: false }
  });

  requests.getTimeSlots = null;
};

export const updateLocationPosition = (locationId, position) => {
  return {
    type: DATASOURCE_ACTION.LOCATION_POSITION_LOAD,
    payload: { locationId, position }
  };
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/actions/dataSourceActions.js